module.exports = __webpack_public_path__ + "img/ponty.7dd15db7.svg";